﻿import React, { forwardRef, ReactNode, useImperativeHandle, useRef, useState } from 'react';

import { Variant } from 'react-bootstrap/esm/types';
import { Alert } from 'react-bootstrap';

const GMetrixBanner = forwardRef((props, forwardRef) => {

    const [message, setMessage] = useState<ReactNode>();
    const [show, setShow] = useState<boolean>(false);
    const [dismissable, setDismissable] = useState<boolean>(false);
    const [variant, setVariant] = useState<Variant>('danger');
    const [extraNode, setExtraNode] = useState<ReactNode>();
    const resolveRef = useRef<any>(null);
    const resolve = resolveRef?.current;

    const createBanner = (message: ReactNode, variant: Variant, dismissable = false, extraNode = undefined) => new Promise(resolve => {

        (resolveRef.current as any) = resolve;

        // add a promise here
        setShow(true);
        setVariant(variant);
        setMessage(message);
        setDismissable(dismissable);
        setExtraNode(extraNode);

    });

    const removeBanner = () => {

        resolveRef.current = resolve;

        // add a promise here
        setShow(false);
        setMessage(null);

    };

    useImperativeHandle(forwardRef, () => ({
        createBanner: createBanner,
        removeBanner: removeBanner
    }), []);

    return (
        <Alert dismissible={dismissable} onClose={removeBanner} show={show} style={{ textAlign: 'center', verticalAlign: 'unset' }} variant={variant}>
            <strong>
                {message}
            </strong>
            {extraNode}
        </Alert>
    );

});

GMetrixBanner.displayName = 'GMetrixBanner';
export default GMetrixBanner;